import React, {useState} from 'react';
import axios from '../axiosConfigLogin';
import {useNavigate} from 'react-router-dom';
import forge from 'node-forge';
import {Box, Button, TextField, Typography} from '@mui/material';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const encryptPassword = async (password) => {
        try {
            const publicKeyResponse = await fetch('/public_key.pem');

            if (!publicKeyResponse.ok) {
                throw new Error('Ошибка загрузки публичного ключа');
            }

            const publicKeyPem = await publicKeyResponse.text();
            const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);
            const encrypted = publicKey.encrypt(password, 'RSAES-PKCS1-V1_5');

            return forge.util.encode64(encrypted);
        } catch (error) {
            console.error('Ошибка при шифровании пароля:', error);
            throw error;
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const encryptedPassword = await encryptPassword(password);
            console.log(encryptedPassword)

            const response = await axios.post('/user/login', { 'identity': username, 'password': encryptedPassword });
            const user_id = response.data.user_id
            const token_response = await axios.post('/user/login-otp', { user_id, 'password': encryptedPassword });

            localStorage.setItem('authToken', token_response.data.access_token);
            navigate('/');
        } catch (error) {
            setError(error.response?.data?.detail || 'An error occurred');
        }
    };

    return (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh">
            <Typography variant="h4">Login</Typography>
            <form onSubmit={handleSubmit}>
                <TextField
                    label="Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    fullWidth
                    margin="normal"
                    required
                />
                <TextField
                    label="Password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    fullWidth
                    margin="normal"
                    required
                />
                {error && <Typography color="error">{error}</Typography>}
                <Button type="submit" variant="contained" color="primary" fullWidth>
                    Login
                </Button>
            </form>
        </Box>
    );
};

export default Login;
